import {Breadcrumb as PepsicoDsBreadcrumb} from '@pepsico-ds/ui'
import PropTypes from 'prop-types'

/**
 * Breadcrumb component that renders a breadcrumb navigation using the PepsicoDsBreadcrumb component.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.uiSchema - The UI schema containing breadcrumb data and styles.
 * @param {Array} props.uiSchema.breadcrumbs - The array of breadcrumb items to be displayed.
 * @param {boolean} [props.uiSchema.isDark=false] - Flag to determine if the breadcrumb should be rendered in dark mode.
 * @param {string} [props.uiSchema.className] - Additional CSS class names to apply to the breadcrumb.
 * @param {string} props.id - The unique identifier for the breadcrumb component.
 * @returns {JSX.Element} The rendered breadcrumb component.
 */
const Breadcrumb = ({uiSchema, id}) => {
  const {breadcrumbs, isDark = false, className} = uiSchema
  return (
    <span 
      id={`breadcrumb` + (id ? `_${id}` : '')} 
      data-testid={`breadcrumb` + (id ? `_${id}` : '')}
    >
      <PepsicoDsBreadcrumb breadcrumbs={breadcrumbs} isDark={isDark} className={className} />
    </span>
  )
}

Breadcrumb.propTypes = {
  uiSchema: PropTypes.shape({
    breadcrumbs: PropTypes.array.isRequired,
    isDark: PropTypes.bool,
    className: PropTypes.string,
  }).isRequired,
  id: PropTypes.string.isRequired,
}

export default Breadcrumb
